/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GoogleReviewAiSettingsRequest = {
    businessType?: string;
    businessCategory?: string;
    businessModel?: GoogleReviewAiSettingsRequest.businessModel;
    toneOfVoice?: GoogleReviewAiSettingsRequest.toneOfVoice;
    /**
     * Free-text rules for what to always include in replies
     */
    alwaysInclude?: string;
    /**
     * Free-text rules for what to never include in replies
     */
    neverInclude?: string;
    brandWordingGuidelines?: string | null;
    supportContactGuidelines?: string | null;
    escalationRules?: string | null;
    additionalRules?: string | null;
    exampleGoodReply?: string | null;
};
export namespace GoogleReviewAiSettingsRequest {
    export enum businessModel {
        OFFLINE = 'offline',
        ONLINE = 'online',
        HYBRID = 'hybrid',
    }
    export enum toneOfVoice {
        FRIENDLY = 'friendly',
        PROFESSIONAL = 'professional',
        CASUAL = 'casual',
        EMPATHETIC = 'empathetic',
        FORMAL = 'formal',
    }
}

